import React from 'react'
import { MenuItem } from '@mui/material'
import { FormValue, RateMode } from 'types'
import { getRateText } from 'services/job'
import { currencyToShortSymbol, roundMonetaryValue } from 'services/formatting'
import SelectCurrencies from 'components/RateField/SelectCurrencies'
import InputGroup from '../InputGroup'
import InputGroupConnector from '../InputGroupConnector'
import SelectField from '../SelectField'
import NumberField from '../NumberField'

export interface IRateFieldProps {
  label?: string
  minRate: number
  maxRate: number
  onMinRateChange: (value: number) => void
  onMaxRateChange: (value: number) => void
  rateMode: RateMode
  onRateModeChange: (value: RateMode) => void
  errorText?: string
  currency: FormValue<string>
  onMinRateBlur: () => void
  onMaxRateBlur: () => void
}

export default class RateField extends React.PureComponent<IRateFieldProps> {
  render() {
    const { minRate, maxRate, rateMode, label, errorText, currency, onMinRateChange, onMaxRateChange, onRateModeChange, onMinRateBlur, onMaxRateBlur } = this.props
    const hasError = !!errorText
    const helperText = errorText || this.getConversionHintText(rateMode, minRate, maxRate)

    return (
      <InputGroup helperText={helperText} error={hasError}>
        <SelectCurrencies currency={currency} style={{ width: 96 }} />
        <NumberField
          onBlur={onMinRateBlur}
          label={label}
          value={roundMonetaryValue(minRate)}
          onChange={onMinRateChange}
          startAdornment={currencyToShortSymbol(currency.input.value || 'USD')}
          name="min_client_rate"
          error={hasError}
        />

        <InputGroupConnector>
          To
        </InputGroupConnector>

        <NumberField
          onBlur={onMaxRateBlur}
          value={roundMonetaryValue(maxRate)}
          onChange={onMaxRateChange}
          startAdornment={currencyToShortSymbol(currency.input.value || 'USD')}
          name="client_rate"
          error={hasError}
        />

        <InputGroupConnector>
          /
        </InputGroupConnector>

        <SelectField value={rateMode} onChange={onRateModeChange} error={hasError} style={{ width: 120 }}>
          <MenuItem value="hour">
            Hour
          </MenuItem>

          <MenuItem value="day">
            Day
          </MenuItem>

          <MenuItem value="month">
            Month
          </MenuItem>

          <MenuItem value="year">
            Year
          </MenuItem>
        </SelectField>
      </InputGroup>
    )
  }

  getConversionHintText(rateMode: RateMode, minRate: number, maxRate: number) {
    let parts = [] as string[]
    const currency = this.props.currency.input.value

    if (rateMode !== 'hour') {
      parts.push(getRateText(minRate, maxRate, rateMode, 'hour', currency, { roundHourlyRate: true }))
    }

    if (rateMode !== 'day') {
      parts.push(getRateText(minRate, maxRate, rateMode, 'day', currency, { roundHourlyRate: true }))
    }

    if (rateMode !== 'month') {
      parts.push(getRateText(minRate, maxRate, rateMode, 'month', currency, { roundHourlyRate: true }))
    }

    if (rateMode !== 'year') {
      parts.push(getRateText(minRate, maxRate, rateMode, 'year', currency, { roundHourlyRate: true }))
    }

    let hintText = parts.filter(part => !!part).join('; ')

    if (hintText) {
      return `Equals ${hintText}`.replace('/hour', '/hr').replace('/month', '/mth').replace('/year', '/yr')
    }

    return ''
  }
}
